import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useContextAccessToken } from '../../permission/contexts/AnonShareTokenContext.js';
import { useResourcesUiStore } from '../stores/useResourcesUiStore.js';
import { DropdownMenu } from '@fabric-app/ui/components/DropdownMenu/DropdownMenu';

const ResourceUiDropdownShowControls = ({ uiContext = "global" }) => {
  const { hideTitle, hideComment, hideTags, toggleTitle, togglePinnedComment, toggleTags } = useResourcesUiStore(uiContext);
  const accessToken = useContextAccessToken();
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsxs(DropdownMenu.ToggleItem, {
        onClick: toggleTitle,
        children: [
          /* @__PURE__ */ jsx("span", {
            children: "Show filename/path"
          }),
          " ",
          /* @__PURE__ */ jsx(DropdownMenu.ToggleItemSwitch, {
            checked: !hideTitle
          })
        ]
      }),
      /* @__PURE__ */ jsxs(DropdownMenu.ToggleItem, {
        onClick: togglePinnedComment,
        children: [
          /* @__PURE__ */ jsx("span", {
            children: "Show comments"
          }),
          " ",
          /* @__PURE__ */ jsx(DropdownMenu.ToggleItemSwitch, {
            checked: !hideComment
          })
        ]
      }),
      !accessToken && /* @__PURE__ */ jsxs(DropdownMenu.ToggleItem, {
        onClick: toggleTags,
        children: [
          /* @__PURE__ */ jsx("span", {
            children: "Show tags"
          }),
          " ",
          /* @__PURE__ */ jsx(DropdownMenu.ToggleItemSwitch, {
            checked: !hideTags
          })
        ]
      })
    ]
  });
};

export { ResourceUiDropdownShowControls };
//# sourceMappingURL=DropdownShowControls.js.map
